/**
 * Who was rejected on the shortlist, or skipped in Write & send — and the way back (Sofia,
 * Oct 19 2026: "they are just gone and I cannot get them back"). Folded away by default.
 */
import type { OutreachCandidate } from '../../types/taOutreach';
import { profileLinkOf } from './profileLink';

const when = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'Europe/Berlin' }) : '';

export function DroppedList({
  title,
  people,
  restoring,
  onRestore,
  restoreLabel,
}: {
  title: string;
  people: OutreachCandidate[];
  restoring: string | null;
  onRestore: (c: OutreachCandidate) => void;
  restoreLabel: string;
}) {
  if (!people.length) return null;
  return (
    <details className="text-[13px]">
      <summary className="cursor-pointer font-semibold">
        {title} ({people.length})
      </summary>
      <ul className="m-0 mt-2 list-none space-y-1.5 p-0">
        {people.map((c) => {
          const link = profileLinkOf(c);
          const reason = c.sourcing?.decision?.reason;
          return (
            <li key={c.id} className="flex flex-wrap items-center gap-2">
              {link ? (
                <a href={link} target="_blank" rel="noreferrer" className="font-semibold text-[#1A1A1A] underline">
                  {c.name}
                </a>
              ) : (
                <span className="font-semibold">{c.name}</span>
              )}
              <span className="text-xs text-[#707070]">
                {[c.headline, reason ? `“${reason}”` : null, when(c.droppedAt)].filter(Boolean).join(' · ')}
              </span>
              <button
                type="button"
                // One restore at a time: each reads a profile through the extension, which takes one job only.
                disabled={Boolean(restoring)}
                onClick={() => onRestore(c)}
                className="text-xs font-semibold text-[#0072EA] underline disabled:opacity-50"
              >
                {restoring === c.id ? 'Restoring…' : restoreLabel}
              </button>
            </li>
          );
        })}
      </ul>
    </details>
  );
}
